import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BreadcrumbLink, Breadcrumbs, Typography } from '@guildeducationinc/recess';
import ActivityHeroImg from '@src/assets/activity-hero-img.png';
import { ActivityList } from '@src/components/Activity/ActivityList/ActivityList';
import { EligibilityNotice } from '@src/components/Employee/EligibilityNotice';
import { EmployeeContext } from '@src/contexts/EmployeeContextProvider';
import { useMyActivities } from '@src/hooks/useMyActivities';
import { useLocale } from 'pe-core-frontend';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import styles from './ActivityPage.module.scss';
export const ActivityPage = () => {
    const { t } = useLocale();
    const { isEligible } = useContext(EmployeeContext);
    const { myActivities, filter, setFilter, hasFilter, loading } = useMyActivities({
        key: 'allActivities',
    });
    return (_jsxs("div", { className: styles.container, children: [_jsxs("div", { className: styles.heading, children: [_jsxs("div", { className: styles.headingContent, children: [_jsxs(Breadcrumbs, { className: styles.breadcrumbs, children: [_jsx(BreadcrumbLink, { component: Link, to: '/', children: t('Home') }), _jsx(BreadcrumbLink, { current: true, children: t('Activity') })] }), _jsx(Typography, { variant: 'h1', children: t('Activity') })] }), _jsx("div", { className: styles.image, style: {
                            backgroundImage: `url(${ActivityHeroImg})`,
                        } })] }), _jsxs("section", { children: [_jsx(EligibilityNotice, {}), (isEligible || hasFilter || myActivities.length > 0) && (_jsx(ActivityList, { showHeader: true, activities: myActivities, filter: filter, setFilter: setFilter, hasFilter: hasFilter, loading: loading }))] })] }));
};
